import './App.css';
import Navigation from "./Components/Navigation/Navigation";
import FrontPage from "./Components/FrontPage/FrontPage";

function App() {
  return (
    <div className="App">
        <FrontPage />
    </div>
  );
}

export default App;
